import type { ReactNode } from 'react';

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@src/design-system/popover';
import { CreateOrEditViewForm } from './create-or-edit-view-form';

export function CreateViewPopover({ trigger }: { trigger: ReactNode }) {
  return (
    <Popover modal>
      <PopoverTrigger asChild>{trigger}</PopoverTrigger>
      <PopoverContent
        align='end'
        className='p-4 w-72 border border-pale-border bg-white rounded-lg'
      >
        <CreateOrEditViewForm />
      </PopoverContent>
    </Popover>
  );
}
